import ApiServices, { InstanceKeys } from "@/api/apexchat.api.services";
import { downloadEmailAttachment } from "@/api/endpoints";
import { downloadFile } from "@/services/generic.methods";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  layouts: [],
  openEditorModal: false,
  selectedTemplate: null,
};

export const emailEditorSlice = createSlice({
  name: "emailEditor",
  initialState: { ...initialState },

  reducers: {
    /**
     * @name @setNotesToState
     * @description set layouts to state
     **/
    setLayoutsToState: (state, action) => {
      if (action?.payload) state.layouts = action?.payload;
    },
    setOpenEditorModalToState: (state, action) => {
      state.openEditorModal = action?.payload;
    },
    setSelectedTemplateToState: (state, action) => {
      state.selectedTemplate = action?.payload;
    },
  },
});

export const {
  setLayoutsToState,
  setOpenEditorModalToState,
  setSelectedTemplateToState,
} = emailEditorSlice.actions;

export const getLayouts = (state) => {
  return state.emailEditor?.layouts;
};
export const getOpenEditorModalState = (state) => {
  return state.emailEditor?.openEditorModal;
};

export const getSelectedTemplate = (state) => {
  return state.emailEditor?.selectedTemplate;
};

export const fetchLayouts = async (dispatch) => {
  fetch("/mock-data/leads/email-template-layouts.json")
    .then((response) => response.json())
    .then((data) => {
      dispatch(setLayoutsToState(data));
    })
    .catch((error) => {
      console.error("Error fetching countries data:", error);
    });
};

export const DownloadEmailAttachment = (
  filename,
  companyKey = "",
  download = true
) => {
  let endpoint = downloadEmailAttachment;
  let queryParams = {
    FileName: filename,
    CompanyKey: companyKey,
    "api-version": 2.0,
  };
  return ApiServices.getFile(
    endpoint,
    {},
    InstanceKeys.crmInstance,
    queryParams
  )
    .then(async (res) => {
      if (res && res?.data) {
        if (download) await downloadFile(res.data, filename);
        return Promise.resolve(res?.data);
      }
      return Promise.reject(false);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default emailEditorSlice.reducer;
